const moduleName = "wasu"

export default {
  name : moduleName,
  api : {
    server : "http://api.magbizcloud.com:8891/",
    app_module : "wasu",
  },
  title : "Wasu Group",
  description : "Job Service",
  logo : "assets/"+moduleName+"/logo.png",               // 128*128 Color Logo
  logo_head : "assets/"+moduleName+"/logo-head.png",      // 200*34 Color Logo
  theme : {
    primary: {
      light: "rgba(89,84,239,0.8)",
      main: "rgba(89,84,239,1)",
      dark: "rgba(89,57,250,1)",
      contrastText: '#fff'
    },
    secondary: {
      light: "rgb(250,250,250,0.9)",
      main: "rgb(250,250,250,0.95)",
      dark: "rgb(250,250,250,1)",
      contrastText: '#424242'
    }
  },
  menu:{
    main_menu: {
  		title: "sidebar.section.main_menu",
  		list: [
  			//{
  			//	"menu_title": "sidebar.dashboard",
  			//	"menu_icon": "view-dashboard",
  			//	"path": "/"+moduleName+"/dashboard",
  			//	"child_routes": null
  			//},
        {
  				"menu_title": "sidebar.services",
  				"menu_icon": "settings-square",
  				"path": "/"+moduleName+"/services",
  				"child_routes": null
  			},
        {
  				"menu_title": "sidebar.services_appointment",
  				"menu_icon": "calendar-alt",
  				"path": "/"+moduleName+"/services/appointment",
  				"child_routes": null
  			},
  		]
  	}
  }
}
